import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    overflow: "auto",
  },
  text: {
    whiteSpace: "pre-wrap",
  },
};
